import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import Surtitle from "../Surtitle";
const DocaposteSection = ({ surtitle = "Votre sur titre", title = "Votre titre", justify = "flex-start", background = "none", width = "60", height = "80", orientation, dynamicPart, ...others }) => {
    dayjs.locale("fr");
    return (_jsx(Stack, { width: "100%", sx: {
            position: "relative",
            ...(background === "blue"
                ? {
                    backgroundColor: "background.header",
                    backgroundImage: "url('/fond-waves.png')",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    color: "primary.contrastText",
                    py: 15,
                }
                : {}),
        }, children: _jsxs(Stack, { spacing: 3, component: "section", sx: {
                alignSelf: "center",
                maxWidth: 1208,
                width: "100%",
                px: { xs: 2, md: 3 },
            }, ...others, children: [_jsxs(Stack, { spacing: 2, sx: { alignItems: justify }, children: [surtitle && (_jsx(Surtitle, { title: surtitle, contrast: background === "blue" })), _jsx(Typography, { variant: "h3", component: "p", sx: background === "blue" ? { color: "primary.contrastText" } : {}, children: title })] }), _jsx(Stack, { sx: {
                        position: "relative",
                        ...(background === "left-rectangle" ||
                            background === "right-rectangle"
                            ? {
                                isolation: "isolate",
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    left: background === "left-rectangle"
                                        ? "calc(50% - 50vw)"
                                        : "auto",
                                    right: background === "right-rectangle"
                                        ? "calc(50% - 50vw)"
                                        : "auto",
                                    width: `${width}vw`,
                                    height: `${height}%`,
                                    backgroundColor: "#F6F6F6",
                                    zIndex: -1,
                                },
                            }
                            : {}),
                    }, children: dynamicPart })] }) }));
};
export default DocaposteSection;
